import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./GamesTabContent.scss";
import { ROUTES } from "../../../utils/constants";
import DownloadAppPrompt from "../../DownloadAppPrompt/DownloadAppPrompt";
import useAuth from "../../../hooks/useAuth";
import useDisclosure from "../../../hooks/useDisclosure";
import HyperBalance from "../../dashboard-page/HyperBalance/HyperBalance";
import useWalletBalances from "../../../hooks/useWalletBalances";
import useInfinitePopularGamesQuery from "../../../react-query/queries/use-infinite-popular-games";
import GameFilters from "../GameFilters/GameFilters";
import { useGamesPageActions } from "../../../hooks/useGamesPage";
import GamesFeeds from "../GamesFeeds/GamesFeeds";
import useGameDetailsBySlugQuery from "../../../react-query/queries/use-game-details-by-slug";

const MAX_PAGES_AT_ONCE = 5;
const MAX_DATA_PER_PAGE = 15;

export default function GamesTabContent() {
  const { slug } = useParams();
  const { isLoggedIn: userIsLoggedIn } = useAuth();
  const { HPR: hprWallet } = useWalletBalances() ?? {};
  const { data: gameDataFromSlug } = useGameDetailsBySlugQuery({
    slug: slug ?? "",
  });
  const { popularGames, query: popularGamesQuery } =
    useInfinitePopularGamesQuery({
      maxPages: MAX_PAGES_AT_ONCE,
      limit: MAX_DATA_PER_PAGE,
    });
  const {
    isOpen: isDownloadAppPromptOpen,
    onOpen: openDownloadAppPrompt,
    onClose: closeDownloadAppPrompt,
  } = useDisclosure();
  const { selectedFilterId, promptDownloadScenario, handleFilterSelection } =
    useGamesPageActions({ openDownloadAppPrompt });
  const { t } = useTranslation();

  return (
    <>
      <div className="MobileOnly GamesPage">
        <div className="GamesPageHeader">
          <GameFilters
            selectedFilterId={selectedFilterId}
            handleFilterSelection={handleFilterSelection}
          />
          {userIsLoggedIn ? (
            <div className="allow-pointer-events HprBalance">
              <HyperBalance balance={hprWallet?.availableBalance} />
            </div>
          ) : (
            <Link
              to={ROUTES.ROOT.LOG_IN}
              className="text-uppercase text-decoration-none allow-pointer-events Grotesk LoginCta"
            >
              {t("login")}
            </Link>
          )}
        </div>

        <GamesFeeds
          initialGame={gameDataFromSlug}
          gamesList={popularGames}
          gamesListQuery={popularGamesQuery}
          maxPages={MAX_PAGES_AT_ONCE}
          openDownloadAppPrompt={openDownloadAppPrompt}
        />
      </div>

      <DownloadAppPrompt
        isOpen={isDownloadAppPromptOpen}
        onOpen={openDownloadAppPrompt}
        onClose={closeDownloadAppPrompt}
        promptDownloadScenario={promptDownloadScenario}
      />
    </>
  );
}
